import { create } from 'zustand';
import type { PublicUser } from '@lira/shared';

export type AuthStatus = 'boot' | 'authed' | 'guest';

interface AuthState {
  /** Access token SÓ em memória — nunca vai para localStorage (o refresh vive em cookie httpOnly). */
  accessToken: string | null;
  user: PublicUser | null;
  status: AuthStatus;
  setSession: (accessToken: string, user: PublicUser) => void;
  setGuest: () => void;
  /** Encerra a sessão local (logout / refresh falhou). */
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  user: null,
  status: 'boot',
  setSession: (accessToken, user) => set({ accessToken, user, status: 'authed' }),
  setGuest: () => set({ accessToken: null, user: null, status: 'guest' }),
  clear: () => set({ accessToken: null, user: null, status: 'guest' }),
}));
